import React, { useState } from "react";
import { useThunk } from "../../hooks/useThunk";
import { sendSupportRequest } from "../../store";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";
import { supportRequestTypes } from "../../constants/commonConstants";

const TaxConsulation = () => {
  const [description, setDescription] = useState("");
  const [touched, setTouched] = useState(false);
  const [doSendRequest, isLoading, error] = useThunk(sendSupportRequest);

  const handleLegalSubmit = async () => {
    setTouched(true);

    if (!description.trim() || description.trim().length > 1000) {
      showToast("error", "Please fill the description correctly.");
      return;
    }

    const data = {
      description: description.trim(),
      requestType: supportRequestTypes.TAX_CONSULT,
    }

    const result = await doSendRequest(data);

    if (result?.success) {
      showToast("success", "Tax consultation request submitted.");
    } else {
      showToast("error", result?.error?.message);
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-[30px]">
      <div className="flex justify-center">
        <div className="w-full ">
          <FormWrapper
            wrapperHeight="h-[510px] sm:h-[524px] md:h-[530px] lg::h-[534px]"
            showDropdown={false}

            // textarea
            textareaLabel="Reason for Contact"
            textareaPlaceholder="Describe your tax concern..."
            textareaValue={description}
            onTextareaChange={(e) => {
              setDescription(e.target.value);
              setTouched(true);
            }}
            textareaError={
              touched && !description.trim()
                ? "This field is required."
                : touched &&  description.trim().length > 1000
                ? "Description must be less than 1000 characters."
                : ""
            }

            // button
            buttonLabel="Request Tax Consultation"
            onSubmit={handleLegalSubmit}
            loading={isLoading}
            disabled={isLoading || !description.trim()}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default TaxConsulation;

